.leaflet-search-map {
  width: 100%;
  height: 100%;
  background: #f7f7f7;
}

.leaflet-search-cluster {
  background: transparent;
  border: 0;

  span {
    display: flex;
    width: 50px;
    height: 50px;
    align-items: center;
    justify-content: center;
    border: 2px solid #fff;
    border-radius: 50%;
    color: #111;
    font-weight: bold;
  }
}
